// extracted by mini-css-extract-plugin
module.exports = {"calculatorheader":"Header_calculatorheader__8k7m1"};